import "../use-safe-layout-effect-wcVibUML.js";
import { t as useCallbackRef } from "../use-callback-ref-BaRDcbom.js";
import { useCallback } from "react";
import { useControlledState } from "@react-stately/utils";
function useDisclosure(r = {}) {
	let { defaultOpen: i, isOpen: a, onClose: o, onOpen: s, onChange: c = () => {} } = r, l = useCallbackRef(s), u = useCallbackRef(o), [d, f] = useControlledState(a, i || !1, c), p = useCallback(() => {
		f(!1), u?.();
	}, [u]), m = useCallback(() => {
		f(!0), l?.();
	}, [l]), h = useCallback(() => {
		(d ? p : m)();
	}, [
		d,
		m,
		p
	]);
	return {
		isOpen: !!d,
		onOpen: m,
		onClose: p,
		onOpenChange: h
	};
}
export { useDisclosure };
